import { Button, Chip, Stack, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { TableCard } from '../../../../components/Section';
import { IJadwaOrder } from '../../../../types/jadwa';
import { JADWA_TRANSFER_STATUS_COLORS, getJadwaOrderTransfers } from './helpers';
import { formatDateTime } from '../../../../utils/date';
import { round2Format } from '../../../../utils/number';

interface JadwaOrderTransfersSummaryProps {
  orders: IJadwaOrder[];
  /** Opens the fund order's tab below. */
  onSelectFundOrder: (tabIndex: number) => void;
}

/**
 * All the wires of this order in one place — one per currency (a SAR fund gets its own SAR transfer). Read only;
 * a transfer is updated from its fund order's tab.
 */
export function JadwaOrderTransfersSummary({ orders, onSelectFundOrder }: JadwaOrderTransfersSummaryProps) {
  const transfers = getJadwaOrderTransfers(orders);

  if (!transfers.length) {
    return null;
  }

  return (
    <TableCard
      title="Transfers in this order"
      description="One wire per currency. Open a fund order to update its transfer."
      sx={{ mb: 2 }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Transfer</TableCell>
            <TableCell>Currency</TableCell>
            <TableCell align="right">Amount</TableCell>
            <TableCell align="right">Original (SAR)</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Fund Orders</TableCell>
            <TableCell>Created</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {transfers.map(({ transfer, fundOrders }) => (
            <TableRow key={transfer.id} hover>
              <TableCell>#{transfer.id}</TableCell>
              <TableCell>{transfer.currency}</TableCell>
              <TableCell align="right">
                {round2Format(Number(transfer.amount) || 0)} {transfer.currency}
              </TableCell>
              <TableCell align="right">{round2Format(Number(transfer.originalAmount) || 0)}</TableCell>
              <TableCell>
                <Chip
                  size="small"
                  variant="outlined"
                  color={JADWA_TRANSFER_STATUS_COLORS[transfer.status] ?? 'default'}
                  label={transfer.status}
                />
              </TableCell>
              <TableCell>
                <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
                  {fundOrders.map(({ fundOrderId, tabIndex }) => (
                    <Button
                      key={fundOrderId}
                      size="small"
                      onClick={() => onSelectFundOrder(tabIndex)}
                      sx={{ minWidth: 0, px: 1 }}
                    >
                      #{fundOrderId}
                    </Button>
                  ))}
                </Stack>
              </TableCell>
              <TableCell>{formatDateTime(String(transfer.createdAt))}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableCard>
  );
}
